<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card custom-modal-card">
      <section class="modal-card-body is-centered-content">
        <button class="nip-close" aria-label="close" @click="close">
          <i class="fas fa-times"></i>
        </button>

        <!-- NIP input -->
        <div v-if="!isConfirmed && !token_invalid" class="has-text-centered">
          <h3 class="modal-title-custom">Validar NIP</h3>
          <p class="modal-subtitle">Por favor, ingresa el NIP para validar tu cuenta</p>
          <div class="formDigits">
            <input
              v-for="(digit, index) in digits"
              :key="index"
              class="custom-nip-input"
              type="text"
              maxlength="1"
              v-model="digits[index]"
              @input="onInput(index)"
              @keydown.backspace="onBackspace(index, $event)"
              @paste="onPaste"
              ref="otpInput"
            />
          </div>
          <div class="notification is-danger has-text-centered" v-if="isError && !isSuccess">
            {{ error }}
          </div>
          <div class="notification is-success has-text-centered" v-if="!isError && isSuccess">
            {{ success }}
          </div>
          <button
            :class="{'is-loading': loading}"
            :disabled="loading"
            class="button custom-validate-btn is-fullwidth"
            @click="confirmarCuenta"
          >
            Validar cuenta
          </button>
        </div>

        <!-- Token inválido -->
        <div v-else-if="!isConfirmed && token_invalid" class="has-text-centered">
          <figure class="is-inline-block">
            <img src="../../assets/token.png" class="img-token" alt="Token inválido">
          </figure>
          <p class="title-error">Token de activación inválido</p>
          <p class="subtitle is-7 has-text-weight-semibold">
            Haz clic nuevamente en el enlace que te enviamos a tu correo electrónico
          </p>
        </div>

        <!-- Confirmado -->
        <div class="confirmed" v-else>
          <div class="confirmed__icon">
            <img src="../../assets/confirm.png" alt="Cuenta confirmada">
          </div>
          <h3>¡Cuenta confirmada con éxito!</h3>
          <p>Tu cuenta ha sido confirmada,<br>ahora inicia sesión para continuar</p>
          <a class="button custom-validate-btn is-fullwidth" href="/login">
            Iniciar Sesión
          </a>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import mixins from '@/mixins/formats'
import { mapActions } from 'vuex'
export default {
  mixins: [mixins],
  props: {
    close: {
      type: Function,
      default: () => {}
    },
    email: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    token_invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      digits: ['', '', '', '', '', ''],
      error: '',
      isError: false,
      success: '',
      isSuccess: false,
      isConfirmed: false,
      loading: false
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleEscapeKey)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleEscapeKey)
  },
  methods: {
    ...mapActions(['confirmAccount', 'resendOtp']),
    handleEscapeKey (event) {
      const isEscapeKey = event.key === 'Escape' || event.keyCode === 27
      if (!isEscapeKey) return
      this.close()
    },
    onInput (index) {
      const current = this.digits[index]
      if (current.length > 1) {
        this.digits[index] = current.charAt(current.length - 1)
      }
      if (this.digits[index] !== '' && index < this.digits.length - 1) {
        this.$refs.otpInput[index + 1].focus()
      }
    },
    onBackspace (index, event) {
      if (this.digits[index] === '') {
        if (index > 0) {
          this.$refs.otpInput[index - 1].focus()
        }
      }
    },
    onPaste (event) {
      event.preventDefault()
      const pasted = (event.clipboardData || window.clipboardData).getData('text')
      const filtered = pasted.replace(/\D/g, '').slice(0, this.digits.length)
      const newDigits = new Array(this.digits.length).fill('')
      filtered.split('').forEach((char, i) => { newDigits[i] = char })
      this.digits = newDigits
      this.$nextTick(() => {
        const nextIndex = Math.min(filtered.length, this.digits.length - 1)
        this.$refs.otpInput[nextIndex].focus()
      })
    },
    getOTP () {
      return this.digits.join('')
    },
    async confirmarCuenta () {
      this.loading = true
      this.isSuccess = false
      this.isError = false
      const result = await this.confirmAccount({ otp: this.getOTP(), token: this.token })
      if (!result.success) {
        this.isError = true
        this.error = result.message
        this.loading = false
        return false
      }
      this.loading = false
      this.isConfirmed = true
    },
    async resend () {
      this.loading = true
      this.success = ''
      this.error = ''
      this.isSuccess = false
      this.isError = false
      const result = await this.resendOtp({ email: this.email })
      if (result.success) {
        this.loading = false
        this.isSuccess = true
        this.success = 'Código enviado a su correo'
      } else {
        this.loading = false
        this.isError = true
        this.error = result.message
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal.is-active {
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-background {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.35);
}

.custom-modal-card {
  max-width: 480px;
  width: 100%;
  padding: 0;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.modal-card-body {
  background: #fff;
  padding: 40px 36px 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 16px;
}

.is-centered-content {
  text-align: center;
  position: relative;
}

.nip-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #b0bac7;
  font-size: 16px;
  padding: 4px;
  line-height: 1;
  &:hover { color: #5a6472; }
}

.modal-title-custom {
  font-size: 22px;
  font-weight: 700;
  color: #283056;
  margin: 0 0 8px;
}

.modal-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 0;
}

.formDigits {
  margin: 28px 0 24px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.custom-nip-input {
  width: 52px;
  height: 60px;
  font-size: 22px !important;
  font-weight: 600;
  border: 1.5px solid #e0e3e9;
  border-radius: 8px;
  text-align: center;
  color: #283056;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  &:focus {
    border-color: #4c70ff;
    box-shadow: 0 0 0 3px rgba(76, 112, 255, 0.15);
  }
}

.custom-validate-btn {
  background-color: #3a5ce0;
  border-color: #3a5ce0;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  min-height: 48px;
  border-radius: 8px;
  margin-top: 8px;
  &:hover {
    background-color: #2d4ecf;
    border-color: #2d4ecf;
    color: #fff;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.confirmed {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0 4px;

  &__icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #f0fdf4;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    img {
      width: 48px;
    }
  }

  h3 {
    font-size: 22px;
    font-weight: 700;
    color: #283056;
    margin: 0 0 8px;
  }

  p {
    font-size: 14px;
    color: #6b7280;
    line-height: 1.6;
    margin: 0 0 24px;
  }
}

.img-token {
  width: 200px;
  margin-bottom: 1rem;
}

.title-error {
  font-weight: 600;
  font-size: 1.25rem;
  color: #283056;
  margin-bottom: 0.75rem;
}
</style>
